import { Box, Typography } from "@mui/material";
import { Grid, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CustomButton from "../../component/Button";
import CustomInput from "../../component/custom-input";
import CustomSelect from "../../component/custom-select";
import { getAllCities, getAllStates, getUserDetailsAPI, updateUserAPI } from "../../api/auth";
import { useNavigate, useParams } from "react-router-dom";

function UserEdit() {
  const { userId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    bio: "",
    email: "",
    phoneNumber: "",
    password: "",
    gotra: "",
    bloodGroup: "",
    mahasabhaVoterId: "",
    gender: "",
    state: "",
    city: "",
    currentAddress: "",
    parmanentAddress: "",
    occupation: "",
    maritalStatus: "",
    marriageDate: "",
  });
  const [astates, setAstates] = useState([])
  const [acities, setAcities] = useState([])

  const getUserData = async () => {
    const res = await getUserDetailsAPI({ id: userId });
    const data = res.data.details;
    if (res.remote === "success") {
      setFormData({
        fullName: data.fullName,
        profileImage: data.userDetails.profileImage,
        bio: data.bio,
        fatherHusbandName: data.fatherHusbandName,
        email: data.userDetails.email,
        phoneNumber: data.phoneNumber,
        password: data.password,
        gender: data.gender,
        state: data.state,
        city: data.city,
        currentAddress: data.userDetails.currentAddress,
        parmanentAddress: data.userDetails.parmanentAddress,
        gotra: data.gotra,
        bloodGroup: data.bloodGroup,
        occupation: data.occupation,
        maritalStatus: data.userDetails.maritalStatus,
        marriageDate: data.userDetails.marriageDate
          ? new Date(data.userDetails.marriageDate)
            .toISOString()
            .substring(0, 10)
          : "",
      });
    } else {
      console.log("API Error:", res);
    }
  };
  useEffect(() => {
    getUserData();
    getStates();
  }, [userId]);

  useEffect(() => {
    if (formData.state && astates.length > 0) {
      const selectedState = astates.find((s) => s.state === formData.state);
      if (selectedState) {
        getCities(selectedState._id);
      }
    }
  }, [astates, formData.state]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "state") {
      const selectedState = astates.find((s) => s.state === value);
      if (selectedState) {
        getCities(selectedState._id);
      }
      setFormData({
        ...formData,
        [name]: value,
        city: "",
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };


  const handleSubmit = async () => {
    console.log("Submitting form data:", formData);
    const payload = {
      id: userId,
      ...formData,
    };
    const response = await updateUserAPI(payload);
    if (response.remote === "success") {
      console.log("Update successful:");
      navigate("/manage-user")
    } else {
      console.error("Update failed:", response);
    }
    console.log(payload, 'payload data')
  };

  const getStates = async () => {
    const resp = await getAllStates();
    if (resp.remote === "success") {
      setAstates(resp.data?.states || []);
    }
  };

  const getCities = async (stateId) => {
    const resp = await getAllCities(stateId);
    if (resp.remote === "success") {
      setAcities(resp.data?.cities || []);
    }
  };

  const StateOptions = [
    { value: "", label: "Select State" },
    ...astates.map((s) => ({ value: s.state, label: s.state })),
  ];

  const CityOptions = [
    { value: "", label: "Select City" },
    ...acities.map((c) => ({ value: c.city, label: c.city })),
  ];

  const Gender = [
    { value: "", label: "" },
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];

  const Occupation = [
    { value: "", label: "" },
    { value: "Private Job", label: "Private Job" },
    { value: "Government Job", label: "Government Job" },
    { value: "Business", label: "Business" },
    { value: "Housewife", label: "Housewife" },
    { value: "Student", label: "Student" },
    { value: "Teacher", label: "Teacher" },
    { value: "Doctor", label: "Doctor" },
    { value: "CA", label: " CA" },
    { value: "Lawyer", label: " Lawyer" },
    { value: "Engineer", label: "Engineer" },
    { value: "Entrepreneur", label: "Entrepreneur" },
    { value: "Bank Employe", label: "Bank Employe" },
    { value: "Retired", label: "Retired" },
  ];

  const MaritalStatus = [
    { value: "", label: "" },
    { value: "Unmarried", label: "Unmarried" },
    { value: "Married", label: "Married" },
    { value: "Divorced", label: "Divorced" },
    { value: "Awaiting Divorced", label: "Awaiting Divorced" },
    { value: "Widowed", label: "Widowed" },
  ];
  const BloodGroup = [
    { value: "", label: "" },
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },


  ];
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ margin: "10px 0" }}
      >
        <Typography
          variant="h5"
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => navigate("/manage-user")}
        >
          <ArrowBackIosIcon />
          {formData.fullName}
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CustomButton
            variant="contained"
            sx={{
              background: "#1ACC43",
              "&:hover": {
                backgroundColor: "#1ACC43",
              },
            }}
            onClick={handleSubmit}
          >
            Approve and Save
          </CustomButton>
          <CustomButton
            variant="contained"
            sx={{
              background: "#FF2B40",
              "&:hover": {
                backgroundColor: "#FF2B40",
              },
            }}
          >
            Delete
          </CustomButton>
        </Stack>
      </Stack>

      <Box className="FormBox">
        <Typography variant="h5">Edit</Typography>
        <Grid container spacing={2}>
          <Grid item lg={12}>
            <CustomInput
              label="User Name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="User's bio"
              name="bio"
              value={formData.bio}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Father/Husband Name"
              name="fatherHusbandName"
              value={formData.fatherHusbandName}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Mobile"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              label="Gender"
              name="gender"
              options={Gender}
              value={formData.gender}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              name="state"
              label="State"
              options={StateOptions}
              value={formData.state}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              name="city"
              label="City/Town"
              options={CityOptions}
              value={formData.city}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Permanent Address"
              name="parmanentAddress"
              value={formData.parmanentAddress}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              name="occupation"
              label="Occupation"
              options={Occupation}
              value={formData.occupation}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomInput
              label="Gotro"
              name="gotra"
              value={formData.gotra}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              label="BloodGroup"
              name="bloodGroup"
              options={BloodGroup}
              value={formData.bloodGroup}
              onChange={handleChange}
            />
          </Grid>
          <Grid item lg={12}>
            <CustomSelect
              name="maritalStatus"
              label="Marital Status"
              options={MaritalStatus}
              value={formData.maritalStatus}
              onChange={handleChange}
            />
          </Grid>
          {formData.maritalStatus === "Married" ? (
            <Grid item lg={12}>
              <CustomInput
                type="Date"
                label="Marriage Date"
                name="marriageDate"
                value={formData.marriageDate}
                onChange={handleChange}
              />
            </Grid>

          ) : (
            <></>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

export default UserEdit;
